/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";
import {BookOfShadowsGameConfig} from "./BookOfShadowsGameConfig";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class BookOfShadowsGameAssets {

    public static INTRO_BACKGROUND: string = "resources/images/intro/introBackground.jpg";
    public static INTRO_LOGO: string = "resources/images/intro/introLogo.png";
    public static INTRO_FEATURE_1 = "resources/images/intro/Feature1/Feature1Reel/Feature1_000";
    public static INTRO_FEATURE_1_SUB = "resources/images/intro/Feature1/3books.png";
    public static INTRO_FEATURE_2 = "resources/images/intro/Feature2/Feature2Reels/Feature2_000";
    public static INTRO_FEATURE_2_SUB = "resources/images/intro/Feature2/ShadowButtons.png";
    public static INTRO_FEATURE_3 = "resources/images/intro/Feature3/Feature3Reels/Feature3_000";
    public static INTRO_FEATURE_4 = "resources/images/intro/Feature4.png";
    public static INTRO_FEATURE_5 = "resources/images/intro/Feature5.png";
    public static INTRO_DIVIDER = "resources/images/intro/Intro_Divider.png";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt")
                ]
            }
        ],
        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json")

                ],
                animations: {
                    "reelDivider": "ui/reelDividers/div",
                    "reelDividerNearWin": "ui/reelDividers/div-attention",
                    "reelsFrame": "Reels_Frame",
                    "reelLockButton": "ReelLockButton/ReelLockButton",
                    "reelLockButtonDown": "ReelLockButton/ReelLockButton_Pressed",
                    "reelLockButtonDisabled": "ReelLockButton/ReelLockButtonDisabled",
                    "reelLockOpen": "ReelLockButton/LockOpen",
                    "reelLock": "ReelLockButton/Lock",
                    "clickTo4": "ShadowRowsButton/RowsButton_Click1/RowsButton_Click1_",
                    "clickTo5": "ShadowRowsButton/RowsButton_Click2/RowsButton_Click2_",
                    "clickTo3": "ShadowRowsButton/RowsButton_Click3/RowsButton_Click3_",
                    "reDrawButton": "FSIntro/reshuffle",
                    "arrow": "FSIntro/arrow",
                    "dividerAnim": "SpinVFX/spinlines_",
                    "bigWinCoin0": "BigWin/CoinC/coinC_",
                    "bigWinCoin1": "BigWin/CoinB/coinB_",
                    "bigWinCoin2": "BigWin/CoinA/coinA_",
                    "betLineWinAmountBg": "betlines/ToggleNumberDarken",
                    "textBox": "ui/TextBox",
                    "whiteArrow": "ui/WhiteArrow",
                    "tapIcon": "ui/tapIcon"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json")
                ],
                animations: {
                    "mainBackground": "mainBackground",
                    "reels": "Reels",
                    "lSymWinAnim": "WinFX/WinFx_",
                    "betHighlight": "BetChangeHighlight/BetChangeHighlight_",
                    "shadowsPushUp": "ShadowPush up/ShadowPushUp_",
                    "bigWinFire": "BW/Fire/BW_Fire_",
                    "bigWinEmber": "BW/ember",
                    "reelAnticipation": "ReelAnticipation/ReelAnticipationFX/ReelAnticipationFX_",
                    "logoFire": "LogoFire/LogoFire_000",
                    "fireParticle1": "fx/SparksParticles/ptA_a",
                    "fireParticle2": "fx/SparksParticles/ptA_b",
                    "fireParticle3": "fx/SparksParticles/ptA_c"
                }
            },
            {
                name: "reelBlockerShadowJpeg",
                assets: [
                    new TextureAsset("reelBlockerShadowJpeg0", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg0.json"),
                    new TextureAsset("reelBlockerShadowJpeg1", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg1.json"),
                    new TextureAsset("reelBlockerShadowJpeg2", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg2.json"),
                    new TextureAsset("reelBlockerShadowJpeg3", "sheets/reelBlockerShadowJpeg/reelBlockerShadowJpeg3.json")
                ],
                animations: {
                    "reelBlockerShadow": "ReelBlockerShadow/ReelBlocker_",
                    "shuffleShadow": "ShuffleShadows/ShuffleShadows_"
                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json")
                ]
            },
            {
                name: "SymbolsJPG",
                assets: [
                    new TextureAsset("SymbolsJPG0", "sheets/SymbolsJPG/SymbolsJPG0.json"),
                    new TextureAsset("SymbolsJPG1", "sheets/SymbolsJPG/SymbolsJPG1.json")
                ],
                animations: {
                    "symbolsTransform": "SymbolTransformFX/SymbolTransformFX_",
                    "sGlowRune": "B/B_bgRunes",
                    "sSpinningGlowRune": "B/B_bgRunes_Spin"
                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("M1_spine", "Spine/symbols/M1_Anim.json"),
                    new SpineAsset("M2_spine", "Spine/symbols/M2_Anim.json"),
                    new SpineAsset("M3_spine", "Spine/symbols/M3_Anim.json"),
                    new SpineAsset("M4_spine", "Spine/symbols/M4_Anim.json"),
                    new SpineAsset("M5_spine", "Spine/symbols/M5_Anim.json"),
                    new SpineAsset("L1_spine", "Spine/symbols/L1_Anim.json"),
                    new SpineAsset("L2_spine", "Spine/symbols/L2_Anim.json"),
                    new SpineAsset("L3_spine", "Spine/symbols/L3_Anim.json"),
                    new SpineAsset("L4_spine", "Spine/symbols/L4_Anim.json"),
                    new SpineAsset("L5_spine", "Spine/symbols/L5_Anim.json"),
                    new SpineAsset("S_spine", "Spine/symbols/S_Anim.json"),
                    new SpineAsset("Big_Win_1", "Spine/BigWin/BW1.json"),
                    new SpineAsset("Big_Win_2", "Spine/BigWin/BW2.json"),
                    new SpineAsset("Big_Win_3", "Spine/BigWin/BW3.json"),
                    new SpineAsset("lockAnim", "Spine/LockAnim.json"),
                    new SpineAsset("cursed", "Spine/CursedAnim.json"),
                    new SpineAsset("reelLock", "Spine/ReelLock.json"),
                    new SpineAsset("bg", "Spine/BG/BGAnim.json")
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        symbolName = symbolName.split("Gold")[0];

        // #22
        if (stateName && stateName.indexOf("Gold") !== -1) {
            return symbolName + "/" + symbolName + stateName;
        }

        // #42
        if (stateName === "noWin" && symbolName === BookOfShadowsGameConfig.instance.FS_SPECIAL_SYMBOL) {
            return symbolName + "/" + symbolName + "Gold";
        }

        if (stateName === null || stateName === "" || stateName === "noWin") {
            return symbolName + "/" + symbolName;
        }

        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(BookOfShadowsGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
}
